import { graphql } from "../gql";

export const setClaimAppealedMutationDoc = graphql(`
  mutation setClaimAppealed($input: SetClaimAppealedInput!) {
    setClaimAppealed(input: $input) {
      id
      appealed
      batchClaimStateById {
        id
        appealed
      }
    }
  }
`);
